export default "__VITE_ASSET__BJLnV9TS__"